import Image from 'next/image';
import Link from 'next/link';

const Brand = () => {
  return (
    <div>
      <Image src="/images/logo/brand.svg" width={130} height={40} alt="logo" />
    </div>
  );
};

export default Brand;
